var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseStudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 2C17.5033 2 18.8971 3.23156 18.9946 4.82187L19 5V9C19.5523 9 20 9.44772 20 10V14C20 14.5523 19.5523 15 19 15V19C19 20.6157 17.6658 21.9049 16.0177 21.995L15.8333 22H9H7.16667C5.4967 22 4.10287 20.7684 4.00544 19.1781L4 19V5C4 3.38432 5.33419 2.09505 6.9823 2.00502L7.16667 2H9H15.8333ZM18 13V11H16V13H18ZM17 9H15C14.4477 9 14 9.44772 14 10V14C14 14.5523 14.4477 15 15 15H17V19L16.9934 19.1057C16.9319 19.5937 16.4507 20 15.8333 20H10V4H15.8333L15.9634 4.0061C16.5599 4.06248 17 4.50196 17 5V9ZM7.16667 4H8V20H7.16667L7.03657 19.9939C6.44013 19.9375 6 19.498 6 19V5L6.00663 4.89429C6.06806 4.40627 6.54935 4 7.16667 4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudy);
export default __webpack_public_path__ + "static/media/CaseStudy.f3b5800f.svg";
export { ForwardRef as ReactComponent };